import { LuAlignJustify } from 'react-icons/lu';

export const ORIENTATION_KEYS = ['user_smer_let', 'user_smer_skla'] as const;
export const PLACING_KEYS = ['user_ornament_skla'] as const;

export enum ConfiguratorOrientation {
  HORIZONTAL = '20',
  VERTICAL = '10',
}

export enum ConfiguratorPlacing {
  OUTER = '20',
  INNER = '10',
}

export const ORIENTATION_TO_ICON = {
  [ConfiguratorOrientation.HORIZONTAL]: <LuAlignJustify className="h-6 w-6" />,
  [ConfiguratorOrientation.VERTICAL]: <LuAlignJustify className="h-6 w-6 rotate-90" />,
};

// TODO: preklady
export const PLACING_TO_LABEL = {
  [ConfiguratorPlacing.INNER]: 'text1194',
  [ConfiguratorPlacing.OUTER]: 'text1195',
};

// TODO: preklady
export const ORIENTATION_TO_LABEL = {
  [ConfiguratorOrientation.HORIZONTAL]: 'text1192',
  [ConfiguratorOrientation.VERTICAL]: 'text1193',
};
